import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {share} from 'rxjs/operators';

export interface VersionChangedEvent {
    version: string;
    version_url: string;
    environment: string;
}

@Injectable({providedIn: 'root'})
export class VersionStreamService {
    private readonly apiUrl = '/api';
    private hadError = false;
    private readonly reconnected = new Subject<void>();

    // Fires when the stream re-opens after a drop — native EventSource replays
    // nothing, so consumers must resync their state at that point.
    readonly reconnected$ = this.reconnected.asObservable();

    readonly events$: Observable<VersionChangedEvent> = new Observable<VersionChangedEvent>((observer) => {
        const source = new EventSource(this.apiUrl + '/status/events');

        source.addEventListener('version_changed', (message: MessageEvent) => {
            try {
                observer.next(JSON.parse(message.data));
            } catch (e) {
                // Ignore malformed payload.
            }
        });

        source.onopen = () => {
            if (this.hadError) {
                this.hadError = false;
                this.reconnected.next();
            }
        };
        source.onerror = () => {
            this.hadError = true;
        };

        return () => source.close();
    }).pipe(share({resetOnRefCountZero: true}));
}
